import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Counter from '../features/counter/Counter';
import Version from '../features/counter/Version';
import { useDispatch, useSelector } from 'react-redux';
import { selectDitaPath, selectTocId, setGuideline } from '../features/counter/counterSlice';

const AcknowledgementModal = React.lazy(() => import('./acknowledgementModal'));
const PdfModal = React.lazy(() => import('./pdfModal'));

const MainContent = ({ referencePopup, search, setReferencePopup, pathname }) => {
  const [displayGuideline, setDisplayGuideline] = useState(false);
  
  const dispatch = useDispatch();
  const tocId = useSelector(selectTocId);

  useEffect(() => {
    dispatch(setGuideline({search: search}));

    if (search.indexOf('topicfile') === -1) {
      setDisplayGuideline(true);
    }
  }, [search]);

  const ditapath = useSelector(selectDitaPath);
  return (
    <div className="container">
      <AcknowledgementModal />
      <PdfModal />
      <div className="slider-arrow show" style={{ 'left': '0px' }} onClick={(e) => { e.preventDefault() }}><i className="flaticon-double30"></i></div>
      <div className="row">
        <div className="col-md-12 mobileContainer">
          <div className="row sectionBlockLayout" style={{
            'textAlign': 'left',
            'minHeight': '100px',
            'padding': '8px 0px 30px 15px',
            'margin': '0px'
          }}>
            <div className="dart-container">

              <div className="maincontent">
                <noscript>You need to enable JavaScript to run this app.</noscript>

                <div className="col-md-3 columnBlockLayout" id="tocId">
                  <div className="tree-menu demo greyboxTopic" id="tocbox">
                    <a id="tocID" dangerouslySetInnerHTML={{ __html: tocId }} />
                    <div id="TOC_ID">
                      {
                        ditapath && (<div id="tg_toc_id">
                            <div className="dartframe fa fa-compress" onClick={() => {
                                document.querySelectorAll("#TOC_ID, #contentId").forEach(el => el.classList.toggle("active"));
                            }}></div>
                            <Version />
                            <Counter pathname={pathname} search={search} setReferencePopup={setReferencePopup} />
                            <span className="username"></span>
                        </div>)
                      }
                    </div>
                  </div>
                </div>

                <div
                  className="col-lg-8 col-md-8 col-sm-8 col-xs-8 columnBlockLayout"
                  style={{
                    'paddingRight': '0px!important',
                    'marginRight': '8px!important'
                  }}
                  id="etgcontent"
                >
                  <div id="contentId">
                    {referencePopup}
                    <div className="bodyContentDiv">
                      <section id="sectionContent"></section>
                    </div>
                  </div>
                  <div className="reader-list">
                    <div id="etgGuidelineBox">
                      { displayGuideline && (<div className="col-lg-6 col-md-6 col-sm-8 topiclist noLeftPaddingXs noRightPaddingXs boxstrnth"><div className="guideline-box mar-t32"></div></div>) }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

MainContent.propTypes = {
  referencePopup: PropTypes.string.isRequired,
  search: PropTypes.string.isRequired,
  setReferencePopup: PropTypes.func.isRequired,
  pathname: PropTypes.string.isRequired,
};

export default MainContent;
